import { normalizeUri } from '../../../utils/utils';
import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
export function toFolder(data, settings) {
  return {
    id: data.id,
    name: data.name,
    kind: ItemKind.Folder,
    source: 'facebook',
    mediaType: MediaType.Picture,
    parentId: null,
    thumbnailUrl: normalizeUri("" + settings.apiUrl + settings.apiPath + "/picture?type=album&album_id=" + data.id),
    filesCount: data.count,
    createdAt: data.created_time
  };
}